import { dataIdSquare } from 'dls-icons-data'
import { createIcon } from '../common'

const IconIdSquare = /*#__PURE__*/createIcon(dataIdSquare)
export default IconIdSquare
